<svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox" aria-hidden="true">
  @for (segment of segments; track segment) {
    <g>
      <circle
        [attr.r]="segment.option.radius"
        [attr.cx]="center"
        [attr.cy]="center"
        [attr.stroke-width]="segment.option.borderWidth"
        [attr.stroke-dasharray]="segment.currentProgress"
        [attr.stroke]="segment.option.color"
        [attr.stroke-dashoffset]="segment.strokeOffset"
        fill="transparent"
      ></circle>
      @if (label) {
        <text [attr.x]="center" [attr.y]="center" text-anchor="middle">
          <tspan [attr.x]="center" [attr.dy]="5">{{label}}</tspan>
        </text>
      }
    </g>
  }
</svg>
